import React, {  useState } from 'react';
import {
  CardTitle,
  Card,
  CardContent,
  Textarea,
  Button,
  Checkbox
} from '../../../Components';
import { MonografiaModel } from '../../../Store';
import styled from 'styled-components';

interface IAlterarNotaModalProps {
  monografia: MonografiaModel,
  onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onTextNCChange: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onTextObsChange: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onAutorizacaoChange: (event: React.ChangeEvent<HTMLInputElement>) => any,
  onAprovar: (monografiaId: number, notaO: number|undefined, 
  notaC: number|undefined,
  obs: string|undefined,
  aut: boolean|undefined) => any,
  notaOValida: boolean|undefined,
  notaCValida: boolean|undefined,
}

const StyledButton = styled(Button) <any>`
  margin-left: 16px
`;

const StyledTextarea = styled(Textarea) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn};
`

const Div = styled.div`
  display: flex;
`

const P = styled.p`
  margin: 0 1em 0 1em;
`

const P2 = styled.p`
  margin: 1em;
`

const P3 = styled.p`
  margin: 1em;
  color: red;
`

export default function AlterarNotaModal(props: IAlterarNotaModalProps) {
  const { monografia, onTextChange, onTextNCChange, 
    onTextObsChange, onAutorizacaoChange, onAprovar, notaOValida, notaCValida } = props;
  const [confirmar, setConfirmar] = useState(false);
  const [autProf, setAut] = useState(monografia.autorizacaoProfessor);

  return (
    <>
      {monografia && 
        <Card>         
          <CardTitle>Atribuir uma nota para a monografia</CardTitle>
          <CardContent>
          <Div>
            <P>Nota do Orientador: </P>
            <StyledTextarea
              name='notaOrientador'
              defaultValue={monografia.notaOrientador ? monografia.notaOrientador : ''}
              maxLength={3}
              onChange={onTextChange}
              gridColumn='1/4'
              disabled={confirmar}
            >
            </StyledTextarea>
            <P>Nota do Convidado: </P>
            <StyledTextarea
              name='notaConvidado'
              defaultValue={monografia.notaConvidado ? monografia.notaConvidado : ''}
              maxLength={3}
              onChange={onTextNCChange}
              gridColumn='1/4'
              disabled={confirmar}
            >
            </StyledTextarea>
            </Div>
            <Div>
            <P2>Observação: </P2>
            <StyledTextarea
              name='observacao'
              defaultValue={monografia.observacao ? monografia.observacao : ''}
              maxLength={255}
              onChange={onTextObsChange}
              gridColumn='1/8'
              disabled={confirmar}
            ></StyledTextarea>            
            </Div>
            <Checkbox 
              label='Autorizo a publicação do trabalho nota 10' 
              checked={Boolean(autProf)}
              onChange={(e: any) => {setAut(e.target.checked); onAutorizacaoChange(e.target.checked); console.log(autProf)}}
            />
            <p></p> 
            {(!notaOValida || !notaCValida) && <P3>Insira notas válidas</P3>}
            {!confirmar &&
              <StyledButton
              onClick={() => {
                if(notaOValida && notaCValida){
                  setConfirmar(true)
                }
              }}>
                Atribuir
              </StyledButton>
            }
            {confirmar && 
            <>
              <StyledButton
                onClick={() => onAprovar(monografia.id,monografia.notaOrientador,
                monografia.notaConvidado,
                monografia.observacao,
                autProf)}>
                Confirmar
            </StyledButton>
            <StyledButton
              onClick={()=>{setConfirmar(false)}}>
                  Cancelar
            </StyledButton>
            </>
            }
          </CardContent>
        </Card>
      }
    </>
  );
}
